import React from "react";
import PropTypes from "prop-types";
import ReactDatepicker from "react-datepicker";
import { momentType } from "custom-prop-types";
import "components/common/datepicker.scss";

export const Datepicker = ({ children, isClearable, onDateSelected, selected, placeholderText }) => (
  <ReactDatepicker
    dateFormat={ ["DD/MM/YYYY", "DD/MM/YY", "D/M/YY", "D/M/YYYY"] }
    isClearable={ isClearable }
    onChange={ dateSelector(onDateSelected) }
    placeholderText={ placeholderText }
    selected={ selected }
  >
    { children }
  </ReactDatepicker>
);

const dateSelector = (onDateSelected) => (date) => onDateSelected(date);

Datepicker.propTypes = {
  children: PropTypes.element,
  isClearable: PropTypes.bool.isRequired,
  onDateSelected: PropTypes.func.isRequired, // (date) => void
  placeholderText: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([momentType, PropTypes.string])
};

Datepicker.defaultProps = {
  children: null,
  selected: null
};



// WEBPACK FOOTER //
// ./src/js/components/common/datepicker.jsx